export const categories = [
  { slug: 'wanghong-baoliao', name: '网红爆料', icon: 'ri-user-smile-line', desc: '网红大V最新黑料与八卦' },
  { slug: 'yule-bagua', name: '娱乐八卦', icon: 'ri-movie-line', desc: '娱乐圈明星最新动态' },
  { slug: 'meiri-dasai', name: '每日大赛', icon: 'ri-fire-line', desc: '每日热门事件大比拼' },
  { slug: 'heiliaoneimu', name: '黑料内幕', icon: 'ri-spy-line', desc: '不为人知的行业内幕' },
  { slug: 'remen-dagua', name: '热门大瓜', icon: 'ri-chat-smile-2-line', desc: '全网最热门的吃瓜合集' },
  { slug: 'zhibo-xiuchang', name: '直播现场', icon: 'ri-live-line', desc: '直播事故与意外现场' },
];

export const hotTags = [
  { id: 1, name: '某顶流塌房', 热度: 98500 },
  { id: 2, name: '网红互撕大战', 热度: 87200 },
  { id: 3, name: '直播翻车现场', 热度: 76100 },
  { id: 4, name: '明星恋情曝光', 热度: 69300 },
  { id: 5, name: '综艺黑幕', 热度: 58400 },
  { id: 6, name: '主播私生活', 热度: 49700 },
  { id: 7, name: '选秀内定', 热度: 42100 },
  { id: 8, name: '代言翻车', 热度: 35800 },
  { id: 9, name: '网红假货风波', 热度: 28900 },
  { id: 10, name: '剧本恋情', 热度: 21300 },
];

export interface Article {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  tags: string[];
  hotLevel: 'hot' | 'explosive' | 'new';
  heat: number;
  publishDate: string;
  author: string;
  content: string;
}

export const articles: Article[] = [
  {
    id: 1,
    slug: 'dingliu-yiren-shuijiao-fengbo',
    title: '某顶流艺人被爆剧组耍大牌，多名工作人员实名爆料',
    excerpt: '近日，多位剧组工作人员实名爆料某顶流艺人在拍摄期间多次迟到、对工作人员态度恶劣，甚至随意更改剧本要求。事件持续发酵中...',
    category: '娱乐八卦',
    categorySlug: 'yule-bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20scene%20with%20warm%20dramatic%20lighting%2C%20film%20set%20background%20blurred%2C%20abstract%20artistic%20style%2C%20warm%20orange%20and%20red%20tones%2C%20minimalist%20composition%2C%20editorial%20photography%20style%2C%20soft%20shadows%2C%20cinematic%20mood%2C%20warm%20cream%20background&width=800&height=500&seq=article-1&orientation=landscape',
    tags: ['顶流', '剧组', '耍大牌'],
    hotLevel: 'explosive',
    heat: 128500,
    publishDate: '2026-07-07',
    author: '吃瓜一线记者',
    content: '<p>近日，一条爆炸性消息在娱乐圈内不胫而走。多位自称某顶流剧组的工作人员通过社交媒体发布实名爆料，指控这位拥有数千万粉丝的当红明星在拍摄期间存在多项不当行为。</p><h2>多名工作人员联合爆料</h2><p>据悉，最先发声的是一位在剧组负责服装的工作人员。其在个人微博发布长文称："忍了很久了，今天必须说出来。这位流量明星在剧组简直无法无天，每天迟到至少两个小时，所有人都在等ta一个人。"</p><p>随后，剧组化妆师、场务等多位工作人员纷纷转发并补充细节。一位不愿透露姓名的摄影师透露："有一次因为ta迟到，整个剧组从早上6点等到中午12点，一天的拍摄计划全部被打乱，损失惨重。"</p><h2>态度恶劣引众怒</h2><p>除了迟到问题，多位工作人员还爆料该明星对工作人员态度极其恶劣。据现场目击者描述，该明星曾在拍摄现场大声训斥一位实习助理，导致该助理当场哭泣并提出辞职。</p><p>"ta对待资深导演和普通工作人员完全是两副面孔，"一位场务人员表示，"对投资人、导演客客气气，转过身就对手下人呼来喝去。"</p><h2>私自修改剧本引争议</h2><p>更让剧组成员不满的是，该明星还多次越权要求修改剧本。据悉，ta曾以"人设不符"为由，要求编剧重写多场重要戏份。当编剧提出异议时，ta直接致电投资人施压，最终编剧被迫妥协。</p><p>一位编剧圈内人士私下表示："这在业内已经不是什么秘密了，很多编剧都怕和这些顶流合作，因为根本没有创作自主权。"</p><h2>事件持续发酵</h2><p>截至目前，该事件已在微博热搜上榜超过12小时，话题阅读量突破3亿。大量网友涌入该明星的社交账号评论区表达不满，要求其出面回应。</p><p>然而，该明星及其工作室目前均保持沉默。有业内人士分析称，工作室可能正在紧急商讨应对方案，预计会在近期发布声明。</p><p>我们将持续关注此事的最新进展。</p>',
  },
  {
    id: 2,
    slug: 'zhiming-wanghong-zhibo-fanche',
    title: '千万粉网红直播带货翻车，产品竟被爆是三无',
    excerpt: '拥有千万粉丝的知名网红在昨晚直播中推销某护肤品，被网友当场扒出该品牌无备案信息，直播间瞬间炸锅，评论区沦陷...',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20scene%20with%20dramatic%20mood%2C%20ring%20light%20glow%2C%20abstract%20artistic%20composition%2C%20warm%20cream%20and%20gold%20tones%2C%20minimalist%20editorial%20style%2C%20soft%20shadows%2C%20warm%20atmosphere%2C%20cinematic%20lighting&width=800&height=500&seq=article-2&orientation=landscape',
    tags: ['直播带货', '翻车', '三无产品'],
    hotLevel: 'explosive',
    heat: 115200,
    publishDate: '2026-07-06',
    author: '爆料小能手',
    content: '<p>昨晚的直播间堪称年度最尴尬翻车现场。一位拥有千万级粉丝的知名带货网红在直播中热情洋溢地推销一款声称"韩国进口"的护肤品套装，却在直播中被网友当场扒出该品牌在国家药监局官网根本查不到备案信息。</p><h2>直播现场炸锅</h2><p>当时直播间人气正旺，在线观看人数超过50万。网红正激情澎湃地介绍这款护肤品"含有珍贵燕窝精华，韩国原装进口"，评论区突然出现大量质疑弹幕。</p><p>"药监局官网根本查不到这个牌子！""大家小心，这是三无产品！""主播你自己用过了吗？"弹幕瞬间刷屏，直播间的氛围从热烈变为尴尬。</p><h2>质疑声四起</h2><p>更有细心的网友发现，该产品包装上标注的生产企业根本不在韩国，而是一家广州郊区的小作坊。出品日期、保质期、生产批号等信息均无法追溯。</p><p>直播间的评论区彻底沦陷。粉丝们分为两派激烈交战：一派要求网红解释清楚，一派则坚持"相信主播不会骗我们"。</p><h2>主播当场回应</h2><p>面对突如其来的质疑，该网红一开始试图无视，继续按照流程介绍产品。但随着评论区越来越失控，ta终于停下来回应："这个产品是我亲自试用了三个月才推荐的，资质证书都在我手上，我会在直播结束后给大家展示。"</p><p>然而，该承诺至今未兑现。截至目前，该网红除了一条模棱两可的"正在核实"动态外，始终未出具任何证明材料。</p><h2>后续影响</h2><p>受此事件影响，该网红的粉丝数量一夜间减少了近20万。多个品牌方紧急宣布终止与其的合作关系。有消费者权益保护组织表示已介入调查此事。</p>',
  },
  {
    id: 3,
    slug: 'zongyi-jiemu-heimu-baoguang',
    title: '热门综艺节目导演被曝操控比赛结果，录音流出',
    excerpt: '一段疑似某热门综艺导演的录音在社交平台疯传，内容涉及操控选手排名、内定冠军等猛料。节目组尚未回应...',
    category: '黑料内幕',
    categorySlug: 'heiliaoneimu',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20backstage%20TV%20studio%20atmosphere%2C%20dramatic%20warm%20lighting%2C%20abstract%20artistic%20style%2C%20dark%20crimson%20and%20gold%20accents%2C%20minimalist%20composition%2C%20editorial%20photography%20mood%2C%20cinematic%20shadows%2C%20warm%20background&width=800&height=500&seq=article-3&orientation=landscape',
    tags: ['综艺', '黑幕', '录音'],
    hotLevel: 'hot',
    heat: 89200,
    publishDate: '2026-07-06',
    author: '内幕知情者',
    content: '<p>一段时长约3分40秒的录音文件昨日深夜在社交平台悄然流出，迅速登上微博热搜。录音中，一位被指认为某热门综艺节目导演的男子，正在与另一人详细讨论如何操纵即将播出的淘汰赛结果。</p><h2>录音内容触目惊心</h2><p>录音中可以清晰听到该男子说："这期走三个，我已经和评委打好招呼了，小张和小李肯定是安全的，那个姓王的得走，他没背景。"随后，该男子又提到："冠军早就定好了，你们正常比就行，结果不会有任何意外。"</p><p>更令人震惊的是，录音中还涉及对选手的人身攻击："那个网红选手别让ta走太远，ta形象不行，品牌方不喜欢。"</p><h2>网友热议</h2><p>录音流出后，网友迅速锁定了对应的节目和选手。该节目当前热度极高，每一期淘汰都牵动千万粉丝的心。如今被爆出一切都是剧本和暗箱操作，粉丝们纷纷表示"被耍了"。</p><p>"我每周为ta投票花了好几百，结果告诉我早就定好了？"一位粉丝愤怒地留言。另一位网友则表示："这种节目不敢看了，全是演的。"</p><h2>节目组回应</h2><p>截至目前，涉事节目组尚未发布任何正式声明。有消息称，节目组内部正在紧急调查录音的泄露来源。法律人士指出，如果录音内容属实，节目组可能涉嫌商业欺诈，需要承担相应法律责任。</p>',
  },
  {
    id: 4,
    slug: 'nv-mingxing-xin-lianqing-baoguang',
    title: '当红女星深夜密会神秘男子，疑似新恋情曝光',
    excerpt: '有媒体拍到某当红女星深夜与一神秘男子同回公寓，两人举止亲密。粉丝纷纷炸锅，工作室电话被打爆...',
    category: '娱乐八卦',
    categorySlug: 'yule-bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20night%20city%20street%20scene%2C%20warm%20street%20lights%2C%20abstract%20artistic%20style%2C%20soft%20bokeh%20background%2C%20warm%20golden%20and%20amber%20tones%2C%20cinematic%20mood%2C%20editorial%20photography%2C%20minimalist%20composition&width=800&height=500&seq=article-4&orientation=landscape',
    tags: ['女星', '恋情', '曝光'],
    hotLevel: 'hot',
    heat: 97300,
    publishDate: '2026-07-05',
    author: '娱乐追踪员',
    content: '<p>昨晚接近午夜时分，某知名娱乐媒体的狗仔队在北京市朝阳区某高档公寓楼下蹲守时，拍到一位当红女星与一名神秘男子并肩走出电梯的画面。两人保持亲密距离，随后一同进入女星的私人住宅，直至次日清晨才先后离开。</p><h2>画面细节</h2><p>根据流出的照片显示，该女星身着一件宽松的黑色卫衣，戴着棒球帽和口罩，打扮极为低调。同行的男子身高约185cm，身材匀称，同样做了严密遮挡。但两人之间的互动细节——包括挽手臂、窃窃私语等亲密动作——仍被镜头清晰捕捉。</p><p>值得注意的是，该男子离开公寓时穿的衣服与昨晚截然不同，进一步引发了同居的猜测。</p><h2>粉丝反应两极</h2><p>消息传出后，该女星的粉丝阵营迅速分裂。一部分粉丝表达祝福："姐姐也是普通人，谈恋爱很正常，尊重她的选择！"</p><p>另一部分粉丝则表示无法接受："现在的重点是搞事业！谈恋爱只会影响她拍戏！"更有极端粉丝在超话发起"请你清醒"的话题，引发激烈争论。</p><h2>工作室沉默</h2><p>截至目前，该女星及其工作室均未对此事做出任何回应。据悉，工作室的电话自今早开始便被打爆，工作人员以"正在核实中"为由婉拒了所有采访请求。</p>',
  },
  {
    id: 5,
    slug: 'wanghong-husi-dazhan-jishi',
    title: '两大顶流网红公开互撕，聊天记录全曝光',
    excerpt: '两位粉丝均超千万的网红突然在社交平台公开互撕，双方你来我往爆出大量黑料，聊天记录、转账截图接连曝光...',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20social%20media%20conflict%20scene%2C%20split%20screen%20abstract%20composition%2C%20warm%20red%20and%20orange%20tension%2C%20minimalist%20editorial%20style%2C%20cinematic%20lighting%2C%20warm%20cream%20background%2C%20soft%20shadows&width=800&height=500&seq=article-5&orientation=landscape',
    tags: ['网红', '互撕', '聊天记录'],
    hotLevel: 'explosive',
    heat: 142600,
    publishDate: '2026-07-05',
    author: '吃瓜一线记者',
    content: '<p>一场堪称年度最大规模的"网红互撕大战"昨日在各大社交平台全面爆发。两位均拥有超过千万粉丝的头部网红——一位以美食探店闻名，另一位以时尚穿搭著称——突然在微博上展开了一场你来我往的骂战，爆出的料一个比一个猛。</p><h2>起因揭秘</h2><p>据知情人士透露，这场纷争的根源在于一场商业合作。半年前，两人共同接了一个品牌的联名推广。但在费用分配环节，双方因"谁贡献的流量更大"产生分歧，裂痕由此埋下。</p><p>事情的导火索则是其中一位网红在直播中"语焉不详地吐槽"对方过河拆桥，被粉丝截图发给另一方后，战火正式点燃。</p><h2>聊天记录全面曝光</h2><p>在长达数小时的互撕过程中，双方先后公开了大量私人聊天记录截图。其中包含涉及金钱分配的内部讨论、对第三方网红的私下评价，以及多笔来历不明的转账记录。</p><p>"这些聊天记录彻底颠覆了ta在粉丝心中的形象，"一位长期关注两位网红的网友评论道，"原来台上姐妹情深，台下互相捅刀。"</p><h2>行业震动</h2><p>这场风波引发了整个网红圈的震荡。多位MCN机构负责人表示，将重新审视旗下达人的言论管理。有品牌方连夜撤下了与涉事网红的合作宣传。</p>',
  },
  {
    id: 6,
    slug: 'xuanxiu-jingji-neiding-neimu',
    title: '选秀节目内定冠军？前工作人员抖音爆料细节',
    excerpt: '一位自称某选秀节目前工作人员的网友在抖音发布系列视频，爆料节目组内定选手的详细操作流程，引发全网热议...',
    category: '黑料内幕',
    categorySlug: 'heiliaoneimu',
    imageUrl: 'https://readdy.ai/api/search-image?query=Reality%20show%20stage%20abstract%20scene%2C%20dramatic%20spotlight%20effect%2C%20warm%20amber%20and%20gold%20lighting%2C%20minimalist%20artistic%20composition%2C%20cinematic%20mood%2C%20editorial%20style%2C%20warm%20background%2C%20soft%20shadows&width=800&height=500&seq=article-6&orientation=landscape',
    tags: ['选秀', '内定', '爆料'],
    hotLevel: 'hot',
    heat: 76500,
    publishDate: '2026-07-04',
    author: '内幕知情者',
    content: '<p>一位自称在某大型选秀节目担任过执行制作助理的网友，近日在抖音平台连续发布了五条爆料视频，详细揭秘了该选秀节目所谓的"公平公正"背后不为人知的操作内幕。</p><h2>爆料核心内容</h2><p>该网友在视频中逐一列举了节目组操纵选手排名的操作方法：包括评委打分"提前沟通"、剪辑偏向性处理（弱化不想要的选手表现，强化力捧选手的镜头）、以及最关键的网络投票"技术干预"。</p><p>"前十名选手的排名，早在节目开播前就确定了80%，"该网友在第三条视频中透露，"剩余20%会根据选手在社交媒体上的反响做微调，但大体框架不会有变化。"</p><h2>具体操作手法</h2><p>据该爆料者描述，节目组会通过以下方式确保"剧本"顺利执行：第一，根据每位选手背后的经纪公司实力和商业价值，预设一个"安全排名区"；第二，通过剪辑手法和导师点评的语言引导，给目标选手制造话题和热度；第三，在投票环节设置隐性权重，让"该走的人走，该留的人留"。</p><h2>行业惯例？</h2><p>该系列视频发布后迅速登上抖音热榜，播放量累计突破5000万。评论区不少自称业内人士的网友表示"这都是公开的秘密"，选秀类节目普遍存在类似操作。</p><p>但节目粉丝的反应更为激烈。大量粉丝涌入该爆料的评论区要求其提供实锤证据，也有人表示"不管真假，至少我追的选手是真有实力的"。</p>',
  },
  {
    id: 7,
    slug: 'zhibo-jian-shiqing-yiwaixianchang',
    title: '知名主播直播间意外事件，10万人目睹尴尬现场',
    excerpt: '某知名游戏主播在直播中不慎暴露私人聊天内容，包含大量敏感信息。弹幕瞬间刷屏，事件迅速登上热搜...',
    category: '直播现场',
    categorySlug: 'zhibo-xiuchang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gaming%20streamer%20live%20setup%20abstract%20scene%2C%20digital%20screen%20glow%2C%20dramatic%20warm%20lighting%2C%20minimalist%20artistic%20composition%2C%20cinematic%20mood%2C%20warm%20cream%20and%20crimson%20tones%2C%20editorial%20style&width=800&height=500&seq=article-7&orientation=landscape',
    tags: ['直播', '意外', '尴尬'],
    hotLevel: 'new',
    heat: 62300,
    publishDate: '2026-07-07',
    author: '直播观察员',
    content: '<p>一场本应寻常的晚间游戏直播，在一瞬间变成了全网热议的焦点。昨晚9时许，一位拥有百万粉丝的知名游戏主播在直播《王者荣耀》排位赛间隙，不小心将个人微信聊天界面投射到了直播画面上，持续了大约15秒才被其发现并慌张关掉。</p><h2>15秒钟内暴露了什么</h2><p>在这短暂的15秒内，眼疾手快的观众截下了大量画面。聊天列表中赫然可见该主播与多名圈内同行的私下对话，内容涉及对其他主播的负面评价、商业合作中的讨价还价、以及一些相当私密的个人话题。</p><p>最令人关注的是其中一条与某经纪公司负责人的对话，内容显示该主播正在"试探性地询问"跳槽的价格，而ta目前的合同尚有两年才到期。</p><h2>弹幕炸裂</h2><p>事发瞬间，弹幕如潮水般涌入："我看到了什么？？？""主播你暴露了！！""卧槽快关掉！！！"一部分观众在惊讶之余疯狂截图，另一部分则在提醒主播。然而当时主播正专注于游戏操作，对弹幕的疯狂刷屏毫无察觉。</p><p>当主播终于注意到异常并慌忙切掉聊天窗口时，直播间的在线人数已飙升至12万——是平时的3倍多。</p><h2>事后补救</h2><p>事件发生后，该主播在直播中解释说"刚才是个意外，请大家不要传播截图"，但为时已晚。各大社交平台上，截图和录屏已经在以惊人的速度扩散。</p><p>今早，该主播发布了一条道歉动态："昨晚确实是我操作失误，不该让私人信息被大家看到。对于因此受到困扰的朋友，我深表歉意。"</p>',
  },
  {
    id: 8,
    slug: 'daipin-mingxing-fanche-xianchang',
    title: '明星代言品牌被曝虚假宣传，消费者集体维权',
    excerpt: '某知名品牌被曝光虚假宣传，代言明星也被卷入风波。消费者自发组织维权群，人数已突破万人...',
    category: '热门大瓜',
    categorySlug: 'remen-dagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Consumer%20rights%20protest%20abstract%20scene%2C%20dramatic%20warm%20lighting%2C%20minimalist%20artistic%20composition%2C%20warm%20red%20and%20gold%20tones%2C%20editorial%20photography%20style%2C%20cinematic%20mood%2C%20soft%20shadows&width=800&height=500&seq=article-8&orientation=landscape',
    tags: ['代言', '虚假宣传', '维权'],
    hotLevel: 'hot',
    heat: 84100,
    publishDate: '2026-07-03',
    author: '消费爆料台',
    content: '<p>一场因明星代言引发的集体维权行动正在网上持续发酵。某知名健康食品品牌因被市场监管部门查出广告宣传严重失实，其代言明星也因此被推上风口浪尖。消费者自发组建的维权群人数在短短三天内突破了一万。</p><h2>虚假宣传详情</h2><p>该品牌主打一款号称"7天瘦10斤"的代餐奶昔，在各大电商平台销量惊人。其广告中请来了两位当红明星担任代言人，广告语信誓旦旦地宣称"不运动、不节食、躺着也能瘦"。</p><p>然而，食品药品监督管理局近日发布的抽检报告显示，该产品的主要成分仅为普通蛋白粉和膳食纤维，其宣称的"进口专利瘦身成分"根本不存在。报告更指出，该产品涉嫌虚假标注营养成分表。</p><h2>消费者损失惨重</h2><p>维权群的发起人李女士告诉记者，她购买了价值3888元的该产品疗程套装，使用了三个月不仅没有瘦，反而出现了肠胃不适的症状。"我完全是冲着这两位明星代言才相信这个产品的，现在感觉自己被欺骗了。"</p><p>据维权群内不完全统计，目前涉及的总金额已超过500万元。群内消费者要求品牌全额退款，并要求代言明星承担连带责任。</p><h2>明星是否担责？</h2><p>法律专家表示，根据《广告法》相关规定，明星代言人需要对广告内容的真实性进行必要的审查。如果明星明知或者应知广告虚假仍进行推荐，需要承担连带责任。</p><p>截至目前，两位涉及代言的明星均未对此事做出回应。其中一位明星的粉丝团则在超话中表示"产品的问题与艺人无关，请分清责任"。</p>',
  },
  {
    id: 9,
    slug: 'jiemu-zu-juben-lianqing-neimu',
    title: '恋爱综艺被爆全有剧本，素人嘉宾都是演员',
    excerpt: '一位自称参加过恋爱综艺的素人嘉宾匿名爆料，称节目中所有CP配对都是提前设计好的剧本，连台词都有提词器...',
    category: '黑料内幕',
    categorySlug: 'heiliaoneimu',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20TV%20show%20set%20abstract%20scene%2C%20soft%20warm%20lighting%2C%20pink%20and%20gold%20tones%2C%20minimalist%20artistic%20composition%2C%20cinematic%20mood%2C%20editorial%20photography%20style%2C%20warm%20background&width=800&height=500&seq=article-9&orientation=landscape',
    tags: ['恋综', '剧本', '演员'],
    hotLevel: 'new',
    heat: 45700,
    publishDate: '2026-07-07',
    author: '综艺揭秘局',
    content: '<p>恋爱真人秀到底有多"真人"？一位自称曾参与某热门恋爱综艺录制的"素人嘉宾"通过匿名渠道向本网站发来了一份长达7000字的爆料信，彻底撕开了恋爱综艺的遮羞布。</p><h2>素人？全是演员</h2><p>据该爆料人披露，节目中所有所谓的"素人嘉宾"实际都是经过精心挑选的演员或准艺人。"选角的时候，导演组会明确告诉我们：你们不是来谈恋爱的，你们是来演戏的。剧本已经写好了，你们只需要按照剧本走就行了。"</p><p>爆料信中还列出了详细的选角标准：男女双方需要在外形上匹配，年龄不能差距太大，学历和工作背景需要有"可包装的空间"。最重要的是——必须签署保密协议。</p><h2>CP配对提前设计</h2><p>更让人震惊的是关于CP配对的细节。"录制开始前一周，导演会一对一告诉我们，节目里你的心动对象是谁，你们需要发展到什么程度，每一期的人设和故事走向是什么。连哪些场景需要意外吻上都安排好了。"</p><p>该爆料人还透露，录制现场确实有提词器，用来提示嘉宾下一步需要做出什么反应："紧张""害羞""吃醋"等情绪都是提前标注的。</p><h2>行业潜规则</h2><p>多位娱乐圈内部人士向记者证实，恋爱综艺存在剧本早已是圈内公开的秘密。一位综艺制作人匿名表示："没有剧本怎么保障收视率？观众想看的就是甜甜的恋爱，我们就给他们看甜甜的恋爱。至于是真是假，who cares？"</p><p>但目前最大的争议在于——这些节目均以"真实记录素人恋爱"为卖点，涉嫌对观众的虚假宣传和误导。</p>',
  },
  {
    id: 10,
    slug: 'wanghong-jiahuo-fengbo-zhuizong',
    title: '网红美妆店被曝售假，粉丝晒检测报告维权',
    excerpt: '多名粉丝在社交平台晒出第三方检测报告，指认某网红自营美妆店售卖假冒国际大牌护肤品。网红本人沉默至今...',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cosmetics%20testing%20lab%20abstract%20scene%2C%20warm%20dramatic%20lighting%2C%20minimalist%20artistic%20composition%2C%20warm%20amber%20and%20cream%20tones%2C%20editorial%20photography%20style%2C%20cinematic%20mood%2C%20soft%20shadows&width=800&height=500&seq=article-10&orientation=landscape',
    tags: ['美妆', '售假', '检测报告'],
    hotLevel: 'hot',
    heat: 91200,
    publishDate: '2026-07-04',
    author: '消费爆料台',
    content: '<p>网红卖假货的雷声从未停歇，这一次被"炸"的是一位以"真实测评"著称的美妆博主。该博主开设的自营美妆店铺被多名粉丝曝光售假，投诉数量正在迅速增长。</p><h2>粉丝晒出检测报告</h2><p>最早发声的是一位购买了某国际大牌精华液的粉丝。她表示，收到产品后首先发现包装印刷模糊，"和我专柜买的完全不一样"。抱着疑问，她自费800元将产品送到了第三方检测机构，结果令人震惊——该产品的核心功效成分含量仅为正品的不到10%。</p><p>这条检测报告的图片在社交平台上引发了连锁反应。截至目前，已有超过20名消费者晒出了各自送检的检测报告，涉及的品牌超过5个，均为国际知名护肤品牌。</p><h2>网红沉默引众怒</h2><p>相比事件的汹涌舆情，涉事网红的处理方式让粉丝更加愤怒。从事件爆发至今，ta没有发布任何解释或回应，只是默默删除了店铺中涉事产品的链接，并在微博设置了"仅半年可见"。</p><p>"昨天还在直播间信誓旦旦地说咱们不卖假货，假一赔十，今天就变缩头乌龟了？"一位购买了售假产品的粉丝在评论区愤怒留言。</p><h2>法律后果</h2><p>律师指出，如果售假行为被查实，该网红不仅需要承担对消费者的民事赔偿责任，还可能面临市场监管部门的行政处罚。如果金额达到一定标准，甚至可能被追究刑事责任。</p>',
  },
  {
    id: 11,
    slug: 'mingxing-shuihou-zhenrong-zhengju',
    title: '多位明星被曝在同一家整形医院秘密手术',
    excerpt: '某整形医院内部员工爆料，多位当红明星曾在该院进行秘密整形手术，并晒出模糊的就诊记录照片...',
    category: '娱乐八卦',
    categorySlug: 'yule-bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Medical%20clinic%20abstract%20interior%2C%20soft%20warm%20lighting%2C%20minimalist%20artistic%20composition%2C%20cream%20and%20white%20tones%2C%20editorial%20photography%20style%2C%20cinematic%20mood%2C%20clean%20shadows&width=800&height=500&seq=article-11&orientation=landscape',
    tags: ['整形', '明星', '秘密'],
    hotLevel: 'new',
    heat: 52100,
    publishDate: '2026-07-06',
    author: '医疗线人',
    content: '<p>整形，一直是娱乐圈讳莫如深的话题。明星们一边信誓旦旦地说"纯天然"，一边却被一次次"扒"出整容前后对比照。而这次，一位来自某知名整形医院的内部员工，直接放了一颗"重磅炸弹"。</p><h2>就诊记录曝光</h2><p>该爆料者在社交平台上公开了多张经过模糊处理的"VIP病房登记表"照片。表格上虽对具体姓名做了打码处理，但根据住院日期、年龄、职业等信息的交叉比对，网友们迅速锁定了对应的明星。</p><p>据不完全统计，出现在这份"秘密名单"中的明星多达十余位，其中多位一直对外宣称自己"从未动过刀"。</p><h2>医院的说法</h2><p>记者就此事联系了涉事整形医院。医院方面首先否认了资料的泄露，声称"所有患者的就诊信息都是严格保密的"。但当被问及是否会对爆料的员工进行追责时，医院方面以"内部事务不便透露"为由拒绝了进一步回应。</p><p>有业内人士分析认为，整形医院泄露明星客户信息的动机可能是为了"隐形宣传"——通过制造话题，暗示自家医院具备"明星级别"的服务能力。</p><h2>明星反应</h2><p>截至发稿时，被点名的多位明星均未做出回应。但其中一位明星的粉丝后援会发布声明称"所有所谓的爆料均为造谣，将保留追究法律责任的权利"。然而这份声明并未能平息网络上的议论。</p>',
  },
  {
    id: 12,
    slug: 'daibo-zhubo-redu-zhibiao',
    title: '带货主播热度排行榜出炉，第一名居然是ta',
    excerpt: '最新一期带货主播综合热度排行榜发布，常年霸榜第一名被神秘黑马超越。网友惊呼：万万没想到...',
    category: '每日大赛',
    categorySlug: 'meiri-dasai',
    imageUrl: 'https://readdy.ai/api/search-image?query=Leaderboard%20ranking%20abstract%20scene%2C%20warm%20dramatic%20lighting%2C%20gold%20and%20crimson%20accents%2C%20minimalist%20artistic%20composition%2C%20editorial%20photography%20style%2C%20cinematic%20mood&width=800&height=500&seq=article-12&orientation=landscape',
    tags: ['排行榜', '带货', '黑马'],
    hotLevel: 'new',
    heat: 38900,
    publishDate: '2026-07-07',
    author: '数据观察员',
    content: '<p>最新一期的带货主播综合热度排行榜于今晨正式发布。与以往不同，这次的榜单给了所有人一个"大大的惊喜"——长期霸占榜首的行业一哥一姐双双跌出前三，一位此前默默无闻的新人主播一举夺魁。</p><h2>黑马崛起之谜</h2><p>这位新晋榜首主播三个月前的粉丝数还不到50万，却在短短一个季度内完成了从腰部到头部的飞跃。根据榜单数据，其在过去30天内的GMV突破了惊人的8亿元，将第二名甩开了整整3个亿的差距。</p><p>更令人侧目的是，ta的成功模式与众不同——不靠低价促销、不靠明星助阵，而是凭借独特的"沉浸式带货"内容风格，赢得了大量高粘性用户的青睐。</p><h2>榜单背后的行业变化</h2><p>行业分析师认为，这份榜单反映出直播带货领域正在发生深层变化：流量红利逐渐消退，内容差异化和用户信任度正在成为新的竞争壁垒。"单纯靠吆喝和低价吸引用户的时代已经过去了，"一位行业分析师表示，"未来能活下来的，一定是那些真正能创造内容价值的直播间。"</p><h2>网友热议</h2><p>榜单发布后，"新带货一哥"的话题迅速登上热搜。大部分网友对这位新晋榜首表达了认可："ta的内容确实好看，我每天都蹲点看。""不硬推产品，把使用体验讲得很真实，我愿意相信ta的推荐。"但也有部分网友质疑数据是否存在刷单的可能，呼吁第三方机构介入调查。</p>',
  },
];

export interface DailyContestItem {
  id: string;
  title: string;
  excerpt: string;
  imageUrl: string;
  votes: number;
}

export const dailyContestArticles: DailyContestItem[] = [
  {
    id: 'contest-1',
    title: '最离谱塌房事件评选',
    excerpt: '网友票选今年最让人大跌眼镜的明星塌房事件TOP10',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20collapse%20abstract%20scene%2C%20shattered%20glass%20effect%2C%20warm%20dramatic%20lighting%2C%20minimalist%20artistic%20composition%2C%20crimson%20and%20gold%20tones%2C%20editorial%20photography%20style&width=600&height=450&seq=contest-1&orientation=landscape',
    votes: 28500,
  },
  {
    id: 'contest-2',
    title: '年度最佳翻车现场',
    excerpt: '直播翻车名场面大赏，哪一个让你笑到肚子疼',
    imageUrl: 'https://readdy.ai/api/search-image?query=Funny%20live%20stream%20fail%20abstract%20scene%2C%20warm%20lighting%2C%20minimalist%20artistic%20composition%2C%20amber%20and%20cream%20tones%2C%20editorial%20photography%20style&width=600&height=450&seq=contest-2&orientation=landscape',
    votes: 22100,
  },
  {
    id: 'contest-3',
    title: '最敢说真话的网红',
    excerpt: '这些网红什么都敢说，句句扎心引发全网共鸣',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bold%20speaker%20abstract%20scene%2C%20megaphone%2C%20warm%20lighting%2C%20minimalist%20artistic%20composition%2C%20gold%20and%20crimson%20tones%2C%20editorial%20photography%20style&width=600&height=450&seq=contest-3&orientation=landscape',
    votes: 19300,
  },
  {
    id: 'contest-4',
    title: '最意想不到的反转剧',
    excerpt: '那些你以为是这样，结果完全相反的爆料事件',
    imageUrl: 'https://readdy.ai/api/search-image?query=Plot%20twist%20abstract%20scene%2C%20dramatic%20warm%20lighting%2C%20minimalist%20artistic%20composition%2C%20gold%20and%20amber%20tones%2C%20editorial%20photography%20style&width=600&height=450&seq=contest-4&orientation=landscape',
    votes: 16700,
  },
  {
    id: 'contest-5',
    title: '最劲爆聊天记录',
    excerpt: '今年流出的聊天记录中，哪一个让你三观尽毁',
    imageUrl: 'https://readdy.ai/api/search-image?query=Phone%20chat%20messages%20abstract%20scene%2C%20dramatic%20warm%20lighting%2C%20minimalist%20artistic%20composition%2C%20crimson%20and%20cream%20tones%2C%20editorial%20photography%20style&width=600&height=450&seq=contest-5&orientation=landscape',
    votes: 15200,
  },
];

export const platformStats = {
  totalArticles: 12860,
  dailyReaders: 980000,
  totalCategories: 6,
  activeContributors: 150,
  monthlyReports: 3200,
  avgDailyPageviews: 2500000,
};

export const faqData = [
  {
    question: '今日吃瓜是什么网站？',
    answer: '今日吃瓜是中国领先的娱乐八卦新闻聚合平台，致力于为吃瓜群众提供最新、最全、最热门的网红爆料、娱乐圈内幕、直播翻车现场等实时资讯。我们聚焦51今日吃瓜、黑料网、每日大赛等高搜索量热词，帮助用户快速找到最新黑料事件与合集资源。',
  },
  {
    question: '如何进行爆料投稿？',
    answer: '您可以通过本站"我要爆料"页面提交爆料信息，也可以发送邮件至 tips@jinrichigua.com。我们承诺对所有爆料人信息进行严格保密，确保您的身份不会被泄露。稿件一经采用，我们将根据新闻价值提供相应的信息费奖励。',
  },
  {
    question: '网站内容是否经过核实？',
    answer: '今日吃瓜遵循新闻传播的基本准则，所有发布的爆料内容均标注信息来源。对于未经证实的传闻，我们会在文中明确标注"未经证实"或"传闻"。我们鼓励用户在阅读时保持理性判断，同时欢迎各方对不实信息提出指正。',
  },
  {
    question: '如何订阅每日瓜报？',
    answer: '您可以在网站底部的订阅框中输入您的邮箱地址，即可免费订阅我们的每日瓜报邮件。订阅后，您将在每个工作日早晨收到最新八卦资讯汇总，不错过任何一个热门大瓜。',
  },
  {
    question: '商务合作怎么联系？',
    answer: '如需进行广告投放、品牌合作、内容授权等商务合作，请发送邮件至 bd@jinrichigua.com，或拨打商务合作热线 400-888-6666 转 3。我们的商务团队将在1个工作日内与您取得联系。',
  },
  {
    question: '投稿爆料有稿费吗？',
    answer: '是的！今日吃瓜平台设有爆料奖励机制。根据爆料的独家性、重要性和时效性，我们提供50元至5000元不等的信息费奖励。特别重大的爆料线索最高可获得10000元奖励。投稿邮箱：tips@jinrichigua.com。',
  },
];